api = {
    URL: "https://abbe.onkiwiplan.com:25202"
}


module.exports = api;


//////////////////
// WEBPACK FOOTER
// ./static/api.config.js
// module id = dw7W
// module chunks = 63